'use strict'

import outputFormDefinition from './outputFormDefinition';

export default [
  {
    name:"projectProductDescription",
    hideButtons: true,
    fields: [
      {
         name: "scopeDetails",
         type: "multiTable",
         options: {
           addEntry: {
             formDefinition: outputFormDefinition
           },
           edit: {
             formDefinition:  outputFormDefinition
           }
         },
         columns: [
           { name: "output", dragable:true },
           { name: "qualityExpectation" },
           { name: "acceptanceCriteria" },
           { name: "acceptanceMethod" },
//           { name: "acceptanceResponsible" },
//           { name: "derivation" },
//           { name: "skills" },
         ]
      },
    ]
  },
  {
    name:"qualityManagementApproach",
    fields: [
      { name: "process", height:5 },
      { name: "tools", height:2 },
      { name: "reporting", height: 3 },
      { name: "timing", height: 2 },
      { name: "roles", height: 2 }
    ]
  } //,
/*
  {
    name:"products",
  },
  {
    name:"qualityRegister",
  }
*/
];



// WEBPACK FOOTER //
// ./views/quality/formDefinition.js